import { Tag } from '@design-system/components/tag/tag';
import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { clsx } from 'clsx';
import exclusiveSubscriptionBanner from '/static/images/home/exclusive-subscription-banner.png';

export const ExclusiveSubscriptionBanner = () => (
  <div className="flex flex-col md:flex-row flex-wrap justify-between gap-6 p-8 bg-white rounded-[20px]">
    <div className="flex flex-col gap-6 grow-1">
      <div className="flex flex-col gap-2">
        <Tag
          label="BETA FEATURE"
          className="bg-[#DA6A02] text-white h-[26px] rounded-[6px]"
          readonly={true}
        />
        <Typography variant="display" size="small">
          Create an exclusive subscription
        </Typography>
      </div>
      <ul className="list-disc pl-4">
        <li>
          <Typography variant="body" size="large" className="flex gap-2 pr-2">
            Pick your price
          </Typography>
        </li>
        <li>
          <Typography variant="body" size="large" className="flex gap-2">
            Offer exclusive content
          </Typography>
        </li>
        <li>
          <Typography variant="body" size="large" className="flex gap-2">
            Control price controlled access
          </Typography>
        </li>
      </ul>
      <a
        className="w-max mt-2"
        href="https://help.playbookapp.io/en/articles/9698798-how-the-exclusive-subscription-model-works"
        target="_blank"
        rel="noreferrer"
      >
        <div
          className={clsx(
            'flex gap-2 px-4 py-2 rounded-[10px]',
            sprinkles({ bg: 'B-100', color: 'W-100' }),
          )}
        >
          <Typography>Learn more</Typography>
        </div>
      </a>
    </div>
    <img
      src={exclusiveSubscriptionBanner}
      className="rounded-[25px] w-full md:w-[40%] self-center"
    />
  </div>
);
